import React from 'react';
import { ActionField } from 'components/fields';
import RefundField from './RefundField';
import CancelAchTransactionField from './CancelAchTransactionField';
import CheckAchBalanceField from './CheckAchBalanceField';

const TransactionActionsField = (props) => {
  const { record, currencyCode, onRefund } = props;

  const isRefunded =
    record?.transactions &&
    record.transactions[0]?.details?.receiptDetails?.refundStatus === 'succeeded';

  const isCurrency =
    record?.transactions && record.transactions[0]?.amount?.currency === currencyCode;

  const isPendingAch = !!record?.details?.achAllocation && record.status === 'PENDING';

  const hideCancelAction = !isPendingAch;

  // RLPR-20420 bank balance check is only meaningful while the ACH debit is still unsettled
  const hideBalanceCheckAction = !isPendingAch || !record?.details?.paymentIntentId;

  const hideRefundAction =
    record.type !== 'DEPOSIT' || record?.status !== 'CONFIRMED' || isRefunded || !isCurrency;

  if (hideRefundAction && hideCancelAction && hideBalanceCheckAction) {
    return null;
  }

  return (
    <ActionField>
      <RefundField onRefund={onRefund} record={record} hideAction={hideRefundAction} />
      <CheckAchBalanceField record={record} hideAction={hideBalanceCheckAction} />
      <CancelAchTransactionField record={record} hideAction={hideCancelAction} />
    </ActionField>
  );
};

export default TransactionActionsField;
